import { z } from 'zod';
import { AllTranslationKeys } from '@anytag/shared-assets';
import { BaseValidations } from '@anytag/shared-validations';

export const PasswordFormSchema = z
  .object({
    password: BaseValidations.PasswordAdvancedSchemaDynamic,
    passwordConfirm: BaseValidations.PasswordConfirmSchema
  })
  .refine(({ password, passwordConfirm }) => password === passwordConfirm, {
    message: AllTranslationKeys.Error.passwordsDoNotMatch,
    path: ['passwordConfirm']
  });
